import React, { useContext, useEffect, useState } from "react";
import { Wheel } from 'react-custom-roulette';
import {
  authRequest,
  authRequestNb,
  fixedNumber,
  refreshToken,
} from "../../../Helper/helper";
import Footer from "../../../Components/HomeComponents/Footer/Footer";
import Navbar from "../../../Components/HomeComponents/Navbar/Navbar";
import Context from "../../../Context/Context";
import styles from "./Spin.module.scss";

const wheelData = [
  { option: '₹10' },
  { option: 'Try Again' },
  { option: '₹1000 Jackpot', style: { backgroundColor: 'gold' }},
  { option: '₹5' },
  { option: '₹500 Jackpot', style: { backgroundColor: 'orange' }},
  { option: 'Try Again' },
  { option: '₹0' },
  { option: 'Try Again' },
];


const Spin = () => {
  const [mustSpin, setMustSpin] = useState(false);
  const [prizeNumber, setPrizeNumber] = useState(0);
  const [message, setMessage] = useState('');
  const [balance, setBalance] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isWinner, setIsWinner] = useState(false);
  const [wonAmount, setWonAmount] = useState('');
  
  const [selectedCurrencyBalance, setSelectedCurrencyBalance] = useState(0);
  const [newBalance, setNewBalance] = useState(0);
  const [selectedCurrency, setSelectedCurrency] = useState("INR");
  useEffect(()=>{
    if(selectedCurrency){
      (async()=>{
        const res = await authRequest({ currency: selectedCurrency }, "balance");
        if(res.status===200){
          setSelectedCurrencyBalance(res.data[0].available_balance);
        }
        else{
          setSelectedCurrencyBalance(0);
        }
      })();
    }
  },[selectedCurrency])
  const handleSpin = async () => {
    try {
      

      const result = await authRequest({ currency: selectedCurrency }, "spin");
      if(result.status===200){
        refreshToken(result.refresh_token);
        // setMessage(result.message);

        const angle = result.angle % 360;
        const segmentAngle = 360 / wheelData.length;
        const index = Math.floor(angle / segmentAngle);

        console.log("index=>",index);
        console.log("selected_index=>",result.selected_index);
        // setPrizeNumber(index);
        setPrizeNumber(result.selected_index);
        // setMustSpin(true);
        setTimeout(() => {
          setMustSpin(true);
          setNewBalance(result.remaining_balance);
        }, 100);
        setMessage('You Lost! Try Again.');
        return;
      }
      else{
        // setMessage(result.message);
        return;
      }
      
    } catch (err) {
      console.error(err);
      setMessage('Error during spin');
    }
  };
    
  const testSpin = () => {
    const randomIndex = Math.floor(Math.random() * wheelData.length);
    setPrizeNumber(randomIndex);
    setTimeout(() => setMustSpin(true), 100);
  };
  return (
    <div className={`${styles.stack_l} stakePage ligtMode`}>
      <Navbar />
      {/* <div className="stakeMain" >
        <div className={`${styles.stack} container`}>
          <div className='row align-items-center justify-content-center'>
            <div className='col-sm-5'>
              <div className="text-center imgmobhide">
                <img src="/stakeimg.png" className="img-fluid" />
              </div>
            </div>
          </div>
      </div>
    </div> */}
    <div className={`${styles.stack} container`}>
      <div className='signPage '>
        <div className="row">
          <div style={{ textAlign: 'center' }}>
          <div className={styles.wheelWrapper}>
          {selectedCurrencyBalance !== null && <h2>Your Balance: ₹{selectedCurrencyBalance}</h2>}
            {/* <div className={styles.wheelContainer}> */}
              <div className={styles.glossyWheel}>
                {/* <WheelWheel
                  mustStartSpinning={mustSpin}
                  prizeNumber={prizeNumber}
                  data={wheelData}
                  onStopSpinning={() => setMustSpin(false)}
                  backgroundColors={['#ffecd2', '#fcb69f', '#a18cd1', '#fbc2eb']}
                  textColors={['#000']}
                  outerBorderColor={'#444'}
                  outerBorderWidth={6}
                  radiusLineColor={'#ccc'}
                  radiusLineWidth={2}
                  fontSize={18}
                /> */}
                <Wheel
                    mustStartSpinning={mustSpin}
                    prizeNumber={prizeNumber}
                    data={wheelData}
                    backgroundColors={['#b2ff59', '#69f0ae', '#00e676', '#1de9b6', '#00bfa5']}
                    textColors={['#000']}
                    outerBorderColor={'#ffeb3b'}
                    outerBorderWidth={10}
                    radiusLineColor={'#ffffff'}
                    radiusLineWidth={2}
                    fontSize={18}
                    onStopSpinning={() => {
                      setMustSpin(false);
                    
                      const wonValue = wheelData[prizeNumber].option;
                      const winMatch = wonValue.match(/₹([\d,]+)/);
                    
                      if (winMatch) {
                        setWonAmount(winMatch[0]);
                        setIsWinner(true);
                      } else {
                        setIsWinner(false);
                      }
                      setSelectedCurrencyBalance(newBalance);
                      setShowModal(true);
                    }}
                  
                  />
                {/* <div className={styles.pointer}></div> */}
                <div className={styles.glossOverlay}></div>
              {/* </div> */}
            </div>
            {/* <button onClick={handleSpin} disabled={mustSpin} style={{ marginTop: 20 }}>
              Spin
            </button> */}
            
            {/* {message && <h6>{message}</h6>} */}

            <button onClick={handleSpin} disabled={mustSpin} className={styles.spinButton}>
                Tap to Spin
              </button>
             
            </div>
            
          </div>
        </div>
      </div>
    </div>
    {showModal && (
  <div className={styles.modalOverlay}>
    <div className={styles.modalContent}>
      <h2>{isWinner ? '🎉 Congratulations!' : '😢 Better Luck Next Time'}</h2>
      <p>
        {isWinner
          ? `You won ${wonAmount}! 🎁`
          : 'Oops! You didn’t win this time. Try again!'}
      </p>
      <button onClick={() => setShowModal(false)}>Close</button>
    </div>
  </div>
)}

    <Footer />
  </div>
  );
};

export default Spin;
